import { React, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope , faLock } from '@fortawesome/free-solid-svg-icons';
function ResetPassword() {
    let [error, setError] = useState('');
    let [token, setToken] = useState('');
    let [showPassword, setShowPassword] = useState(false);
    let [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
     function togglePassword() {
        setShowPassword(showPassword => !showPassword);
    }
    function togglePasswordConfirmation() {
        setShowPasswordConfirmation(showPasswordConfirmation => !showPasswordConfirmation);
    }
    function handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if(!token){
            setError("الرمز غير صالح");
            return;
        }
        setToken(token);
        if(data.get('password') !== data.get('password_confirmation')){
            setError("كلمة المرور وتأكيد كلمة المرور غير متطابقين");
            return;
        }
        const postData = {
            token: token,
            new_password: data.get('password'),
        };
        axios.post('https://rechargemoi.ma/backend/api/update_password', postData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            const js = res.data;
            if (res.status === 200) {
                alert("تم تغيير كلمة المرور بنجاح");
                res.data.token && localStorage.setItem('token', res.data.token);
                window.location.href = '/';
            } else {
                setError("الرجاء التحقق من البيانات وإعادة المحاولة");
            }
        }).catch((err) => {
            setError("حدث خطأ أثناء تغيير كلمة المرور");
        });
    }
    return (
        <div className="container">
            <h2 className="mt-5">تغيير كلمة المرور</h2>
            <p>يرجى إدخال كلمة المرور الجديدة لتغيير كلمة المرور الخاصة بك.</p>
            {error && <div className="alert alert-danger">{error}</div>}
            <form method="POST" onSubmit={handleSubmit}>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            <FontAwesomeIcon icon={faLock} />
                        </span>
                    </div>
                    <input 
                        type={showPassword ? "text" : "password"} 
                        className="form-control" 
                        id="password" 
                        name="password" 
                        placeholder="كلمة المرور الجديدة"
                        required 
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            <FontAwesomeIcon icon={faLock} />
                        </span>
                    </div>
                    <input 
                        type={showPasswordConfirmation ? "text" : "password"} 
                        className="form-control" 
                        id="password_confirmation" 
                        name="password_confirmation" 
                        placeholder="تأكيد كلمة المرور الجديدة"
                        required 
                    />
                </div>
                <div className="form-check mb-3">
                    <input 
                        type="checkbox" 
                        className="form-check-input" 
                        id="showPassword" 
                        onChange={togglePassword} 
                    />
                    <label className="form-check-label" htmlFor="showPassword">إظهار كلمة المرور</label>
                </div>
                <div className="form-check mb-3">
                    <input 
                        type="checkbox" 
                        className="form-check-input" 
                        id="showPasswordConfirmation" 
                        onChange={togglePasswordConfirmation} 
                    />
                    <label className="form-check-label" htmlFor="showPasswordConfirmation">إظهار تأكيد كلمة المرور</label>
                </div> 
                <div className="d-grid gap-2">
                    <button type="submit" className="btn btn-primary">تغيير كلمة المرور</button>
                </div>
            </form>
        </div>
    );
}
export default ResetPassword;